import { useState, useCallback } from "react";
import { getSharableCollectionData } from "../services/tokenTiger";
import configJSON from '../config.json'
export const useAppState = () => {
  const [data, updateData] = useState([]);
  const [selectedToken, updateSelectedToken] = useState(null);
  const [dataAlreadyLoaded, setDataAlreadyLoaded] = useState(false)
  const [selectedCollection, setSelectedCollection] = useState(null)
  const [tokensData, setTokensData] = useState({})

  const sharables = configJSON.urls
  // Get sharable data
  const getSharablesData = useCallback(async () => {
    try {
      if (dataAlreadyLoaded) return data

      const newData = []
      // map all sharables to get the data
      for (const sharable of sharables) {
        // get sharable url inputs: userId and publicId  
        // url format: https://share.tokentiger.com/users/share/nft/userId/publicId
        const userId = sharable.split('/')[6]
        const publicId = sharable.split('/')[7]
        const sharableData = await getSharableCollectionData({ userId, publicId })
        const tokens = sharableData.tokens
        // map all tokens to get the data
        newData.push({
          userId,
          publicId,
          sharableData,
          tokens,
        })
      }
      updateData(newData)
      setDataAlreadyLoaded(true)
      return newData
    } catch (error) {
      console.error(error)
      return []
    }
  }, [sharables, dataAlreadyLoaded, data])

  return {
    data,
    updateData,
    selectedToken,
    updateSelectedToken,
    getSharablesData,
    selectedCollection,
    setSelectedCollection,
    tokensData,
    setTokensData
  };
}
